import React from 'react';
import { Divider } from '@mui/material';
import { GlobalSettingsNumberGrid } from '../../../pages/admin/GlobalSettingsNumberGrid';
import {
  gatewayNumberFields,
  runtimeTtlNumberFields,
} from '../../../pages/admin/global-settings.config';
import { GeneratedImageHostsField } from './GeneratedImageHostsField';
import { SettingsSectionHeader } from './SettingsSectionHeader';
import type { AiRuntimeSectionProps } from './settingsSectionTypes';

export const AiRuntimeSection: React.FC<AiRuntimeSectionProps> = ({
  config,
  onNumberChange,
  onImageHostsChange,
}) => (
  <>
    <SettingsSectionHeader
      title="AI gateway runtime"
      description="Values are stored in the global Setting table and cached for runtime reads."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={gatewayNumberFields}
      onNumberChange={onNumberChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Chat runtime cache TTLs"
      description="How long the KV/memory snapshots used by the chat stream stay valid. The FE warms them once per session; the Durable Object refreshes the session snapshot after each turn."
    />
    <GlobalSettingsNumberGrid
      config={config}
      fields={runtimeTtlNumberFields}
      columns={3}
      onNumberChange={onNumberChange}
    />

    <Divider className="my-6" />

    <SettingsSectionHeader
      title="Generated images"
      description="Where a model may return an image as a link. Links on other hosts are rejected before they are fetched."
    />
    <GeneratedImageHostsField
      hosts={config.generatedImageAllowedHosts}
      onChange={onImageHostsChange}
    />
  </>
);
